import { Tabs, Tab } from 'components/CncUI/Tabs';
import ContentBox from 'components/CncUI/ContentBox';

import W2Documents from './W2Documents';
import W4Documents from './W4Documents';
import ActivityLogs from './ActivityLogs';
import SearchControls from './SearchControls';
import Grid from '@material-ui/core/Grid';

const TABS = {
  W2: 0,
  W4: 1,
  T4: 2,
  TD1: 3,
  LOGS: 4,
};

const TabsSection = props => {
  const { documents = {}, refresh, onClear, onModify } = props;
  const filteredDocuments = () => {
    switch (documents.tab) {
      default:
      case TABS.W2:
        return documents.w2s.filter(
          document =>
            !['T4', 'T4A', 'Releve 1', 'T4ANR', 'NR4'].includes(document.name),
        );
      case TABS.T4:
        return documents.w2s.filter(document =>
          ['T4', 'T4A', 'Releve 1', 'T4ANR', 'NR4'].includes(document.name),
        );
      case TABS.W4:
        return documents.w4s;
      case TABS.TD1:
        return documents.td1s;
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Tabs value={documents.tab} onChange={(_, tab) => onModify({ tab })}>
          <Tab>W2 Documents</Tab>
          <Tab>W-4 Documents</Tab>
          <Tab>T4 Documents</Tab>
          <Tab>TD1 Documents</Tab>
          <Tab>Activity Logs</Tab>
        </Tabs>
      </Grid>
      <Grid item xs={12}>
        <SearchControls
          state={documents}
          loading={documents.loading}
          onSearch={refresh}
          onClear={onClear}
          onModify={onModify}
        />
      </Grid>
      <Grid item xs={12}>
        <ContentBox dense transparent>
          {(documents.tab === TABS.W2 || documents.tab === TABS.T4) && (
            <W2Documents
              data={filteredDocuments()}
              searchValue={documents.searchValue}
              tab={documents.tab}
              onSuccess={() => refresh(documents.searchValue)}
            />
          )}
          {(documents.tab === TABS.W4 || documents.tab === TABS.TD1) && (
            <W4Documents tab={documents.tab} data={filteredDocuments()} />
          )}
          {documents.tab === TABS.LOGS && (
            <ActivityLogs data={documents.logs} />
          )}
        </ContentBox>
      </Grid>
    </Grid>
  );
};

export default TabsSection;
